import React from 'react'

const Rating = ({ width = 98.52, height = 110 }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 98.52 110"
  >
    <g transform="translate(7.368 47.804)" opacity="0.3">
      <path
        d="M4.3,36.981H22.633V27.9H11.154A6.874,6.874,0,0,0,4.3,34.754Z"
        transform="translate(-4.3 -27.9)"
        fill="#b18935"
      />
    </g>
    <g transform="translate(5.14 61.168)" opacity="0.43">
      <path
        d="M25.274,69.968H9.854A6.874,6.874,0,0,1,3,63.114V42.554A6.874,6.874,0,0,1,9.854,35.7H25.274a6.874,6.874,0,0,1,6.854,6.854V63.114A6.874,6.874,0,0,1,25.274,69.968Z"
        transform="translate(-3 -35.7)"
        fill="#b18935"
      />
    </g>
    <g transform="translate(71.106 82.586)" opacity="0.43">
      <circle cx="13.707" cy="13.707" r="13.707" fill="#b18935" />
    </g>
    <g transform="translate(47.975 64.595)" opacity="0.43">
      <circle cx="3.427" cy="3.427" r="3.427" fill="#b18935" />
    </g>
    <g transform="translate(37.695 74.875)" opacity="0.3">
      <circle cx="3.427" cy="3.427" r="3.427" fill="#b18935" />
    </g>
    <g transform="translate(68.536 64.595)" opacity="0.3">
      <circle cx="3.427" cy="3.427" r="3.427" fill="#b18935" />
    </g>
    <g transform="translate(77.103 54.315)" opacity="0.43">
      <circle cx="3.427" cy="3.427" r="3.427" fill="#b18935" />
    </g>
    <g transform="translate(37.091 3.17)" opacity="0.43">
      <path
        d="M37.843,3.135l2.741,5.483a2.18,2.18,0,0,0,1.542,1.2l6.168.857a2.132,2.132,0,0,1,1.2,3.6l-4.455,4.283a2.577,2.577,0,0,0-.685,1.885l1.028,6.168A2.111,2.111,0,0,1,42.3,28.836l-5.483-2.913a1.849,1.849,0,0,0-1.885,0l-5.483,2.913a2.141,2.141,0,0,1-3.084-2.227l1.028-6.168a2.038,2.038,0,0,0-.685-1.885l-4.455-4.283a2.149,2.149,0,0,1,1.2-3.6l6.168-.857a2.18,2.18,0,0,0,1.542-1.2L33.9,3.135C34.93,1.422,36.986,1.422,37.843,3.135Z"
        transform="translate(-21.648 -1.85)"
        fill="#b18935"
      />
    </g>
    <g transform="translate(67.939 20.175)" opacity="0.43">
      <path
        d="M50.529,12.675l1.885,3.941c.171.514.685.685,1.028.857l4.283.685a1.535,1.535,0,0,1,.857,2.57L55.5,23.812a1.333,1.333,0,0,0-.343,1.371l.685,4.283a1.445,1.445,0,0,1-2.056,1.542l-3.769-2.056a1.877,1.877,0,0,0-1.371,0l-3.769,2.056a1.415,1.415,0,0,1-2.056-1.542l.685-4.283a1.846,1.846,0,0,0-.343-1.371l-3.084-3.084a1.535,1.535,0,0,1,.857-2.57l4.283-.685a1.086,1.086,0,0,0,1.028-.857l1.885-3.941A1.249,1.249,0,0,1,50.529,12.675Z"
        transform="translate(-39.652 -11.775)"
        fill="#b18935"
      />
    </g>
    <g transform="translate(14.824 20.175)" opacity="0.43">
      <path
        d="M19.529,12.675l1.885,3.941c.171.514.685.685,1.028.857l4.283.685a1.535,1.535,0,0,1,.857,2.57L24.5,23.812a1.333,1.333,0,0,0-.343,1.371l.685,4.283a1.445,1.445,0,0,1-2.056,1.542l-3.769-2.056a1.877,1.877,0,0,0-1.371,0l-3.769,2.056a1.415,1.415,0,0,1-2.056-1.542l.685-4.283a1.846,1.846,0,0,0-.343-1.371L9.077,20.727a1.535,1.535,0,0,1,.857-2.57l4.283-.685a1.086,1.086,0,0,0,1.028-.857l1.885-3.941A1.249,1.249,0,0,1,19.529,12.675Z"
        transform="translate(-8.652 -11.775)"
        fill="#b18935"
      />
    </g>
    <g transform="translate(86.355 53.287)">
      <path
        d="M50.4,31.1"
        transform="translate(-50.4 -31.1)"
        fill="none"
        stroke="#454e5b"
        strokeMiterlimit="10"
        strokeWidth="1"
      />
    </g>
    <g id="Grupo_729" data-name="Grupo 729">
      <path
        d="M24.425,18.162a1.259,1.259,0,0,1,.343,1.028l-1.028,6.168a3.1,3.1,0,0,0,1.2,2.913,2.86,2.86,0,0,0,3.084.171l5.483-2.913a1.464,1.464,0,0,1,1.2,0l5.483,2.913a4.032,4.032,0,0,0,1.371.343,2.9,2.9,0,0,0,1.713-.514,3.1,3.1,0,0,0,1.2-2.913L43.444,19.19c0-.343,0-.857.343-1.028l4.455-4.283a2.9,2.9,0,0,0,.685-3.084,2.98,2.98,0,0,0-2.4-2.056l-6.168-.857A1.138,1.138,0,0,1,39.5,7.2L36.761,1.713A3,3,0,0,0,34.191,0a2.806,2.806,0,0,0-2.57,1.713L28.88,7.2a1.138,1.138,0,0,1-.857.685l-6.168.857a2.737,2.737,0,0,0-2.4,2.056,3.392,3.392,0,0,0,.685,3.084Zm-3.6-6.854a1.086,1.086,0,0,1,1.028-.857L28.023,9.6A3.018,3.018,0,0,0,30.25,8.053L32.992,2.57a1.285,1.285,0,0,1,2.227,0l2.741,5.483A2.64,2.64,0,0,0,40.188,9.6l6.168.857a1.086,1.086,0,0,1,1.028.857,1.059,1.059,0,0,1-.343,1.2l-4.455,4.283a2.982,2.982,0,0,0-.857,2.57l1.028,6.34a1.555,1.555,0,0,1-.514,1.2,1.293,1.293,0,0,1-1.371.171l-5.483-3.084a4.032,4.032,0,0,0-1.371-.343,3.228,3.228,0,0,0-1.371.343L27.166,26.9a1.341,1.341,0,0,1-1.371-.171,1.555,1.555,0,0,1-.514-1.2l1.028-6.168a2.828,2.828,0,0,0-.857-2.57L21,12.508A1.407,1.407,0,0,1,20.827,11.308Z"
        transform="translate(13.784)"
        fill="#454e5b"
      />
      <path
        d="M41.256,23.593a.629.629,0,0,1,.171.514l-.685,4.283a2.231,2.231,0,0,0,.857,2.227,2.416,2.416,0,0,0,2.4.171l3.769-2.056a.321.321,0,0,1,.514,0l3.769,2.056a2.435,2.435,0,0,0,1.028.343,1.946,1.946,0,0,0,1.371-.514,2.231,2.231,0,0,0,.857-2.227l-.685-4.283a.629.629,0,0,1,.171-.514l3.084-3.084a2.122,2.122,0,0,0,.514-2.4A2.47,2.47,0,0,0,56.5,16.568l-4.283-.685c-.171,0-.343-.171-.514-.343l-1.371-3.769a2.227,2.227,0,0,0-4.112,0L44.34,15.712c-.171.171-.343.343-.514.343l-4.283.514a2.345,2.345,0,0,0-1.371,3.941ZM39.2,18.624c0-.171.171-.343.514-.343L44,17.6a2.477,2.477,0,0,0,1.713-1.2L47.6,12.456a.557.557,0,0,1,1.028,0L50.508,16.4a2.063,2.063,0,0,0,1.713,1.2l4.283.685a.634.634,0,0,1,.514.343c0,.171.171.343-.171.685l-3.084,3.084a2.354,2.354,0,0,0-.685,2.056l.685,4.283a.75.75,0,0,1-.171.514c-.171,0-.343.171-.685,0l-3.769-2.056a1.713,1.713,0,0,0-2.056,0l-3.769,2.056c-.343.171-.514,0-.685,0s-.343-.171-.171-.514l.685-4.283a2.354,2.354,0,0,0-.685-2.056L39.371,19.31A1.03,1.03,0,0,1,39.2,18.624Z"
        transform="translate(26.766 7.419)"
        fill="#454e5b"
      />
      <path
        d="M10.156,23.664a.629.629,0,0,1,.171.514l-.685,4.283a2.231,2.231,0,0,0,.857,2.227,1.946,1.946,0,0,0,1.371.514,2.435,2.435,0,0,0,1.028-.343L16.666,28.8a.321.321,0,0,1,.514,0l3.769,2.056a2.384,2.384,0,0,0,2.4-.171,2.231,2.231,0,0,0,.857-2.227l-.685-4.283a.629.629,0,0,1,.171-.514l3.084-3.084a2.122,2.122,0,0,0,.514-2.4A2.47,2.47,0,0,0,25.4,16.64l-4.283-.685c-.171,0-.343-.171-.514-.343l-1.885-3.941a2.227,2.227,0,0,0-4.112,0l-1.885,3.941c-.171.171-.343.343-.514.343l-3.769.685A2.345,2.345,0,0,0,7.071,20.58ZM8.1,18.7c0-.171.171-.343.514-.343l4.283-.685a2.477,2.477,0,0,0,1.713-1.2L16.5,12.527a.557.557,0,0,1,1.028,0l1.885,3.941a2.063,2.063,0,0,0,1.713,1.2l4.283.685a.634.634,0,0,1,.514.343.6.6,0,0,1-.171.685l-2.913,3.084a2.354,2.354,0,0,0-.685,2.056l.685,4.112a.75.75,0,0,1-.171.514c-.171,0-.343.171-.685,0l-3.769-2.056a2.435,2.435,0,0,0-1.028-.343,2.435,2.435,0,0,0-1.028.343l-3.769,2.056c-.343.171-.514,0-.685,0s-.343-.171-.171-.514l.685-4.283a2.354,2.354,0,0,0-.685-2.056L8.442,19.21C8.1,19.21,8.1,18.867,8.1,18.7Z"
        transform="translate(4.58 7.348)"
        fill="#454e5b"
      />
      <path
        d="M36.407,44.908h19.7L66.22,34.8l-1.2-1.2-9.6,9.6h-19.7L26.3,52.619H21.5v1.713h5.483Z"
        transform="translate(15.338 23.97)"
        fill="#454e5b"
      />
      <rect
        width="17.134"
        height="1.713"
        transform="translate(38.551 85.156)"
        fill="#454e5b"
      />
      <rect
        width="17.134"
        height="1.713"
        transform="translate(39.408 52.601)"
        fill="#454e5b"
      />
      <rect
        width="20.561"
        height="1.713"
        transform="translate(38.551 90.296)"
        fill="#454e5b"
      />
      <path
        d="M92.523,64.038V34.91a7.678,7.678,0,0,0-7.71-7.71H14.05a7.678,7.678,0,0,0-7.71,7.71v1.713A8.043,8.043,0,0,0,0,44.334V64.895a7.713,7.713,0,0,0,6.34,7.539v3.255a7.678,7.678,0,0,0,7.71,7.71H70.763A14.548,14.548,0,0,0,95.95,73.462,15.1,15.1,0,0,0,92.523,64.038Zm-90.81.857V44.334a6.071,6.071,0,0,1,6-6H23.131a6.071,6.071,0,0,1,6,6V64.895a6.071,6.071,0,0,1-6,6H7.71A6.071,6.071,0,0,1,1.713,64.895ZM14.05,81.686a6.071,6.071,0,0,1-6-6V72.6H23.131a7.678,7.678,0,0,0,7.71-7.71V44.334a7.678,7.678,0,0,0-7.71-7.71H8.053V34.91a6.071,6.071,0,0,1,6-6H84.813a6.071,6.071,0,0,1,6,6V62.325A14.165,14.165,0,0,0,81.386,58.9,14.552,14.552,0,0,0,66.822,73.462a13.794,13.794,0,0,0,2.57,8.224Zm67.336,4.626a12.85,12.85,0,1,1,12.85-12.85A12.944,12.944,0,0,1,81.386,86.312Z"
        transform="translate(0 19.404)"
        fill="#454e5b"
      />
      <path
        d="M47.285,51.913h4.8L46.6,57.4l1.371,1.2,5.312-5.483v4.8H55V50.2h-7.71Z"
        transform="translate(33.244 35.812)"
        fill="#454e5b"
      />
      <rect
        width="3.427"
        height="3.427"
        transform="translate(11.994 50.888)"
        fill="#454e5b"
      />
      <rect
        width="3.427"
        height="3.427"
        transform="translate(18.847 50.888)"
        fill="#454e5b"
      />
      <rect
        width="1.713"
        height="2.056"
        transform="translate(22.274 69.05)"
        fill="#454e5b"
      />
      <rect
        width="1.713"
        height="2.056"
        transform="translate(22.274 72.819)"
        fill="#454e5b"
      />
      <g transform="translate(14.564 64.595)">
        <path
          d="M18.067,52.064V38.7H9.5v2.227h.857"
          transform="translate(-7.787 -36.987)"
          fill="none"
        />
        <path
          d="M8.5,37.7v3.941h1.713V39.413H18.78V52.778H15.354v1.713h5.14V37.7Z"
          transform="translate(-8.5 -37.7)"
          fill="#454e5b"
        />
      </g>
    </g>
    <g id="Grupo_730" data-name="Grupo 730" transform="translate(9.424 68.536)">
      <path
        d="M5.5,56.62H17.494V40H5.5ZM7.213,41.713H15.78V54.907H12.354v-4.8H10.64v4.8H7.213Z"
        transform="translate(-5.5 -40)"
        fill="#fff"
      />
      <rect
        width="1.713"
        height="2.056"
        transform="translate(2.57 4.283)"
        fill="#fff"
      />
      <rect
        width="1.713"
        height="2.056"
        transform="translate(7.71 4.283)"
        fill="#fff"
      />
      <rect
        width="1.713"
        height="2.056"
        transform="translate(2.57 8.224)"
        fill="#fff"
      />
      <rect
        width="1.713"
        height="2.056"
        transform="translate(7.71 8.224)"
        fill="#fff"
      />
      <path
        d="M45.285,51.2v1.713h4.8L44.6,58.4l1.371,1.2,5.312-5.483v4.8H53V51.2Z"
        transform="translate(22.394 -32.01)"
        fill="#fff"
      />
    </g>
  </svg>
)

export default Rating
